import { c as _c } from "react/compiler-runtime";
import { ProductActionsOriginType, ProductsActionOrigin } from '@spa/lib/tracking/trackProductActions';
import ProductTileComponent, { Product as ProductTileProduct } from '@spa/components/product-list/product-tile/product-tile.component';
import { WishlistsActionOrigin, WishlistsActionsOriginType } from '@spa/lib/tracking/trackWishlistsActions';
import ImageComponent from '@spa/components/image-component/image.component';
import { Image as ImageData } from '@spa/pages-converters/cms/components/convertCmsImageWoId';
import Link from 'next/link';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { PageTemplate } from '@spa/lib/cms/const';
import { ProductTileContext } from '@spa/components/product-list/product-tile/product-tile.context';
import { ProductTileContextValue } from '@spa/components/product-list/product-tile/product-tile.context';
import { ReactElement } from 'react';
import classNames from 'clsx';
import selectCountryCode from '@spa/lib/store/settings/selectors/selectCountryCode';
import selectGeneralSettings from '@spa/lib/store/settings/selectors/selectGeneralSettings';
import selectLastQueryMetadata from '@spa/lib/store/search/selectors/selectLastQueryMetadata';
import selectLocale from '@spa/lib/store/settings/selectors/selectLocale';
import selectPageTemplate from '@spa/lib/store/router/selectors/selectPageTemplate';
import selectPricesIncludeTax from '@spa/lib/store/settings/selectors/selectPricesIncludeTax';
import selectSearchSettings from '@spa/lib/store/settings/selectors/selectSearchSettings';
import selectWishlistSettings from '@spa/lib/store/settings/selectors/selectWishlistSettings';
import styles from './navigation-promotion.component.module.scss';
import useFullPath from '@spa/lib/react/hooks/useFullPath';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
import useNextAuthOrSession from '@spa/lib/react/hooks/useNextAuthOrSession';
import { usePathname } from 'next/navigation';
import { usePopularityEventsAPI } from '@spa/lib/react/hooks/usePopularityEventsAPI';
import { useSelector } from 'react-redux';
export interface NavigationLink {
  readonly label: string | null;
  readonly path: string | null;
}
export interface ProductTileData {
  readonly headline: string | null;
  readonly product: ProductTileProduct | null;
}
export interface BannerData {
  readonly headline: string | null;
  readonly image: ImageData | null;
  readonly link: NavigationLink | null;
}
export interface Props {
  readonly bottomAlignBanner: boolean;
  readonly banner: BannerData | null;
  readonly productTileData: ProductTileData | null;
  readonly expandBanner: boolean;
}
export const NavigationPromotion = t0 => {
  const $ = _c(33);
  const {
    banner,
    bottomAlignBanner,
    expandBanner,
    productTileData
  } = t0;
  const namespacedIntl = useNamespacedIntl("product-tile");
  const {
    formatMessage
  } = namespacedIntl;
  const locale = useSelector(selectLocale);
  const countryCode = useSelector(selectCountryCode);
  const {
    preOrderEnabled
  } = useSelector(selectGeneralSettings);
  const lastQueryMetadata = useSelector(selectLastQueryMetadata);
  const pageTemplate = useSelector(selectPageTemplate);
  const pricesIncludeTax = useSelector(selectPricesIncludeTax);
  const {
    popularityEventsEnabled
  } = useSelector(selectSearchSettings);
  const {
    plpEnabled: isWishlistEnabled
  } = useSelector(selectWishlistSettings);
  const {
    fullPath
  } = useFullPath();
  const sessionsData = useNextAuthOrSession();
  const {
    sendClickEvent
  } = usePopularityEventsAPI();
  const pathname = usePathname();
  let t1;
  if ($[0] !== countryCode || $[1] !== fullPath || $[2] !== isWishlistEnabled || $[3] !== lastQueryMetadata || $[4] !== locale || $[5] !== namespacedIntl || $[6] !== pageTemplate || $[7] !== pathname || $[8] !== popularityEventsEnabled || $[9] !== preOrderEnabled || $[10] !== pricesIncludeTax || $[11] !== sendClickEvent || $[12] !== sessionsData) {
    t1 = {
      countryCode,
      fullPath,
      isWishlistEnabled,
      lastQueryMetadata,
      locale,
      namespacedIntl,
      pageTemplate,
      pathname,
      popularityEventsEnabled,
      preOrderEnabled,
      pricesIncludeTax,
      sendClickEvent,
      sessionsData
    };
    $[0] = countryCode;
    $[1] = fullPath;
    $[2] = isWishlistEnabled;
    $[3] = lastQueryMetadata;
    $[4] = locale;
    $[5] = namespacedIntl;
    $[6] = pageTemplate;
    $[7] = pathname;
    $[8] = popularityEventsEnabled;
    $[9] = preOrderEnabled;
    $[10] = pricesIncludeTax;
    $[11] = sendClickEvent;
    $[12] = sessionsData;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  const productTileContextValue = t1;
  let t2;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      originId: "navigation-flyout",
      originType: ProductsActionOrigin.NAVIGATION_FLYOUT
    };
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  const productActionOrigin = t2;
  let t3;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      originId: WishlistsActionOrigin.NAVIGATION_FLYOUT,
      originType: WishlistsActionOrigin.NAVIGATION_FLYOUT
    };
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const wishlistActionOrigin = t3;
  const bannerImage = banner?.image;
  const product = productTileData?.product;
  let t4;
  if ($[16] !== expandBanner) {
    t4 = () => classNames(styles["nav-flyout-promotion__banner-wrapper"], {
      [styles["nav-flyout-promotion__banner-wrapper--expanded"]]: expandBanner
    });
    $[16] = expandBanner;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const bannerClassnames = t4;
  let t5;
  if ($[18] !== formatMessage || $[19] !== product || $[20] !== productTileData) {
    t5 = productTileData && <div className={styles["nav-flyout-promotion__product-tile-wrapper"]}><p className={styles["nav-flyout-promotion__headline"]}>{productTileData.headline ?? formatMessage("topProducts")}</p>{product && <ProductTileComponent product={product} priority={false} productActionOrigin={productActionOrigin} wishlistActionOrigin={wishlistActionOrigin} productIndex={0} isFlyout={true} />}</div>;
    $[18] = formatMessage;
    $[19] = product;
    $[20] = productTileData;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== banner || $[23] !== bannerClassnames || $[24] !== bannerImage || $[25] !== bottomAlignBanner) {
    t6 = banner && bannerImage?.src && <div className={bannerClassnames()}>{bottomAlignBanner ? <p className={styles["nav-flyout-promotion__headline"]}>{banner.headline ?? "\xA0"}</p> : banner.headline && <p className={styles["nav-flyout-promotion__headline"]}>{banner.headline}</p>}<Link prefetch={false} href={banner.link?.path ?? ""} aria-label={bannerImage.alt ?? ""}><ImageComponent src={bannerImage.src} className={styles["nav-flyout-promotion__banner-image"]} alt={bannerImage.alt ?? ""} width={bannerImage.width} height={bannerImage.height} /></Link></div>;
    $[22] = banner;
    $[23] = bannerClassnames;
    $[24] = bannerImage;
    $[25] = bottomAlignBanner;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== t5 || $[28] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  let t8;
  if ($[30] !== productTileContextValue || $[31] !== t7) {
    t8 = <ProductTileContext.Provider value={productTileContextValue}>{t7}</ProductTileContext.Provider>;
    $[30] = productTileContextValue;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  return t8;
};